import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AssetProductService } from '../../services/asset-product-service';
import { AssetProduct } from 'src/app/assabil-kernel/models/entities/control-tables/asset-product-entity';
import { MatDialogRef } from '@angular/material/dialog';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';



@Component({
    selector: 'asset-product-lov',
    templateUrl: './asset-product-lov.component.html',
    styleUrls: ['./asset-product-lov.component.scss']
})

export class AssetProductLov extends GenericLovComponent{
  
  // Filter fields
  // ---------------------------------------------------
  code      : string;
  equipment : boolean = true;
  spares    : boolean = false;
  // ---------------------------------------------------


    assetProducts : AssetProduct[] = [];

    columns = [
        { prop: 'assetProductCode',  name: 'Code'},
        { prop: 'name',              name: 'Name' }
    ]

    constructor(
        public dialogRef: MatDialogRef<AssetProductLov>,
        protected assetProductService: AssetProductService,
        protected toastr: ToastrService,
        protected router: Router,
        protected location : Location) {
            super();
    }
      
    loadData() {
        this.assetProductService.assetProductsGet(this.code, this.equipment, this.spares).then(result => {
            this.assetProducts = result;
        })
    }

    //----------------------------------------------------------------------------------------------------------------
    closeModal(assetProduct : AssetProduct){
        this.dialogRef.close(assetProduct);
    }
     //----------------------------------------------------------------------------------------------------------------
    

}
